import Vue from 'vue'
import Vuex from 'vuex'
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id,
  name: payload.name,
  position: payload.position,
  phone: payload.phone,
  email: payload.email,
  customer_id: payload.customer_id
})
var crud = new Crud('Contacts', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  contacts: [],
  isModalVisible: false
}

const mutations = {
  ...crud.mutations,
  SET_CUSTOMERS (state, payload) {
    state.customers = payload.data
  },
  SET_MODAL_CONTACT_VISIBLE (state, payload) {
    state.isModalVisible = payload
  }
}

const actions = {
  ...crud.actions,
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_CONTACT_VISIBLE', payload)
  },
  resetRecords ({ commit }) {
    commit('SET_RECORDS', {
      data: [],
      currentPage: 1,
      perPage: 5,
      totalUsers: 0,
      totalPages: 0
    })
  }
}

const getters = {
  ...crud.getters,
  contacts: state => state.contacts,
  isModalVisible: state => state.isModalVisible
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
